import baseStyles from '../Base/Base.styles'
import merge from 'lodash/merge'
import baseAvatarStyles from '../BaseAvatar/BaseAvatar.styles'
import baseSvgStyles from '../BaseSvg/BaseSvg.styles'

export default properties => {
  
  const { base, background, quoteTextColor, quoteAvatar, quoteSvg } = properties

  let jss = {
    root: {
      ...baseStyles(base),
      ...baseSvgStyles(quoteSvg),
      '& .surface': {
        background: background,
        borderRadius: 'var(--themeShape)'
      },
      '& .surface-text': {
        marginLeft: '25px'
      },
      '& .quote-icon': {
        position: 'relative',
        width: '0',
        top: '-4px'
      },
      '& .quote-icon svg': {
        width: '20px',
      },
      '& .quote-left': {
        display: 'inline-block',
        left: '-22px',
      },
      '& .quote-right': {
        display: 'inline-block',
      }
    }
  }

  jss = merge(jss, {
    root: {
      '& .surface': {
        position: 'relative',
        color: quoteTextColor,
        padding: '20px',
      },
      '& .quote-avatar': {
        ...baseAvatarStyles(quoteAvatar),
        marginTop: '20px'
      }
    }
  }) 

  return jss
}
